import { Button } from '@talentmesh/ui/components/button';
import { Plus } from 'lucide-react';
import { useState } from 'react';
import { useClientsOverviewContext } from '../contexts/ClientsOverviewContext';
import { ClientFormValues } from './Client';
import ClientFormDialog from './ClientForm/ClientFormDialog';
import UIStrings from '@/Utils/UIStrings';

const ClientAddButton = () => {
    const [open, setOpen] = useState(false);
    const { createClient } = useClientsOverviewContext();

    const onSubmit = async (client: ClientFormValues) => {
        try {
            await createClient(client);
            setOpen(false);
        } catch {
            // Keep the dialog open on error.
        }
    };

    return (
        <>
            <Button onClick={() => setOpen(true)} variant="default">
                <Plus data-icon="inline-start" className="size-4" />
                {UIStrings.CreateCompany}
            </Button>
            <ClientFormDialog open={open} onClose={() => setOpen(false)} onSubmit={onSubmit} />
        </>
    );
};

export default ClientAddButton;
